export const isImgMedia = (media) =>
  ['jpg', 'png', 'jpeg'].includes(
    media?.split('.').pop().toString().toLowerCase(),
  );
